import { AddBroadcastAffiliation as AddBroadcastAffiliationComponent } from './AddBroadcastAffiliation.component';
import { connector } from './AddBroadcastAffiliation.connector';

export const AddBroadcastAffiliation = connector(AddBroadcastAffiliationComponent);
